// Before.js
import { FaSearch, FaNetworkWired, FaQuestionCircle, FaMehRollingEyes } from "react-icons/fa";

const BeforeItem = ({ icon: Icon, title, text }) => (
  <div className="flex flex-col md:flex-row items-start space-y-4 md:space-y-0 md:space-x-4 py-4">
    <div className="text-7xl text-[#002b5b] m-auto md-m-none ">
      <Icon />
    </div>
    <div className="pl- md:pl-4 text-left">
      <h3 className="text-2xl font-semibold text-gray-700 py-4 ">{title}</h3>
      <p className="text-gray-600 text-lg leading-relaxed py-1 md:w-4/5 w-full ">{text}</p>
    </div>
  </div>
);

export default function Before() {
  const items = [
    {
      icon: FaSearch,
      title: "カメラ選びが難しい",
      text: "用途や設置環境に合った機種を自分で決めようにも、何を基準に選ぶかがわからない。",
    },
    {
      icon: FaMehRollingEyes,
      title: "比較が大変",
      text: "せっかく条件を絞り込んでも、各社で類似商品がありすぎて最終的な決め方がわからないこともよく聞くお悩みです。",
    },
    {
      icon: FaNetworkWired,
      title: "工程がバラバラ",
      text: "カメラの手配・設置工事・アフターサポートなどの作業フローが分断されていて、設置までに多くの業者を介することになり、さまざまなコストが嵩むことになるのが現状です。",
    },
    {
      icon: FaQuestionCircle,
      title: "導入後の不安",
      text: "トラブル発生時にその原因がわからず、初期対応遅れの可能性とそれによる一時的にでも不安定なセキュリティに。",
    },
  ];

  return (
    <>
      <section className="bg-cover bg-center bg-white pt-24 pb-12 px-4">
        <div className="w-11/12 mx-auto mb-10">
          <h2 className="text-[clamp(50px,10vw,80px)] font-bold text-[#002b5b]">Too complex</h2>
          <p className="text-[#002b5b] mt-2 mb-15 pl-1 underline text-xl">
            複雑すぎるこれまでの設置フロー
          </p>
          <p className="text-black text-lg leading-relaxed hidden">
            通常、防犯カメラを設置するには、複数の業者や工程を経る必要があり、
            <br className="hidden md:inline" />
            選定から設置完了までには多くの手間と時間がかかります。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-11/12 mx-auto">
          {items.map((item, index) => (
            <BeforeItem key={index} {...item} />
          ))}
        </div>

        <div
          className="w-full h-12 md:h-20 bg-cover bg-center bg-white"
          style={{
            backgroundImage: "url('/images/')",
            clipPath: "polygon(50% 100%, 0 0, 100% 0)",
          }}
        />
      </section>

      <div
        className="w-full h-12 md:h-20 bg-cover bg-center bg-white"
        style={{
          backgroundImage: "url('/images/')",
          clipPath: "polygon(50% 100%, 0 0, 100% 0)",
        }}
      />
    </>
  );
}
